const WORDS = ["Live Music", "Summer Nights", "Fallsview", "Dine", "Dance", "Stay the Night", "Niagara Falls"];

const Row = () => (
  <div className="flex shrink-0 items-center" aria-hidden="true">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display text-6xl font-extrabold uppercase sm:text-8xl ${i % 2 ? "text-outline" : "text-white"}`}>{w}</span>
        <span className="h-4 w-4 rotate-45 bg-sunset" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[#0E0F14] py-8" role="presentation">
    <div className="marquee-track flex w-max">
      <Row /><Row />
    </div>
  </div>
);
